
<error-error-content 
  image="assets/img/images/error-images/image1.png"
  errorType="GONE"
  copy="ERROR_410"></error-error-content>

